import { Discussion } from "models/Discussion";
import axios from "axios";
import { GenericService, Service } from "./genericService";
import PublicUser from "models/PublicUser";

class DiscussionService
  extends GenericService<Discussion>
  implements Service<Discussion>
{
  constructor() {
    super("api/Discussion");
  }

  getUserDiscussions = async (): Promise<any[]> => {
    const result = await axios.get(`${this.baseUrl}/getAll`);
    return result.data;
  };

  getFullDiscussion = async (
    discussionId: number,
    page: number,
    startDate: Date
  ): Promise<any[]> => {
    const result = await axios.get(
      `${this.baseUrl}/fullDiscussion/${discussionId}/${page}?startDate=${startDate.toISOString()}`,
    );
    return result.data;
  };

  getGuests = async (discussionId: number): Promise<PublicUser[]> => {
    const result = await axios.get(
      `${this.baseUrl}Member/toInvite/${discussionId}`,
    );
    return result.data;
  };

  sendMessage = async (message: string, discussionId: number): Promise<boolean> => {
    const result = await axios.post(`${this.baseUrl}Message/SendMessageToGroup`, {
      message,
      discussionId,
    });

    if (result.data.result == 'Unauthorized') {
      return false;
    }

    return true;
  };

  invite = async (discussionId: number, userId: string) => {
    await axios.post(`${this.baseUrl}Member/invite?userId=${userId}&discussionId=${discussionId}`);
  }
}

export default new DiscussionService();
